import { State, useHookstate } from '@hookstate/core'
import { useTranslation } from 'react-i18next'
import { ChangeHistoryItem } from '../../../../domain/items'
import styled from 'styled-components'
import { Tabs } from 'antd'
import { useEffect } from 'react'
import { HistoryItemCard } from './history-item-card.component'

const { TabPane } = Tabs

const ItemChangesContainerSection = styled.div`
  padding: 0rem 2.4rem 1.6rem;
`
const HistoryItemTabs = styled.div``

type ItemChangesListProps = {
  historyItems: State<ChangeHistoryItem[]>
}

const ItemChangesContainer = (props: ItemChangesListProps) => {
  const { historyItems } = props
  const { t } = useTranslation()
  const historyItemsTabs = useHookstate<string[]>([])
  const selectedHistoryItemsTab = useHookstate<string>('')

  useEffect(() => {
    historyItemsTabs.set([])
    const totalHistoryItemTabs = ['picker', 'client', 'agent', 'driver']
    showHistoryItemTabsByActionType(totalHistoryItemTabs)

    if (historyItemsTabs.get().length > 0) {
      selectedHistoryItemsTab.set(historyItemsTabs.get()[0])
    }
  }, [])

  const showHistoryItemTabsByActionType = (totalHistoryItemTabs: string[]): void => {
    totalHistoryItemTabs.forEach((historyItemTab) => {
      const itemsByAction = historyItems
        .get({ noproxy: true })
        .filter((historyItem) => historyItem.actionType.toLowerCase().includes(historyItemTab))

      if (itemsByAction.length > 0) {
        historyItemsTabs.set([...historyItemsTabs.get({ noproxy: true }), historyItemTab])
      }
    })
  }

  return (
    <ItemChangesContainerSection>
      {historyItemsTabs.get().length > 0 && (
        <HistoryItemTabs>
          <Tabs activeKey={selectedHistoryItemsTab.get()} onTabClick={(key) => selectedHistoryItemsTab.set(key)}>
            {historyItemsTabs.get().map((keyTab) => (
              <TabPane tab={t<string>(keyTab)} key={keyTab}>
                {JSON.parse(JSON.stringify(historyItems.get()))
                  .filter((historyItem) => historyItem.actionType.toLowerCase().includes(selectedHistoryItemsTab.get()))
                  .map((historyItem: ChangeHistoryItem) => {
                    return <HistoryItemCard historyItem={historyItem} />
                  })}
              </TabPane>
            ))}
          </Tabs>
        </HistoryItemTabs>
      )}
    </ItemChangesContainerSection>
  )
}

export { ItemChangesContainer }
